import { styles } from 'consts';
import styled from 'styled-components';

const { titleColor, secondaryBlack, fontMontserrat, whiteDarker, secondaryBg } = styles;

interface IProps {
  fillContent?: boolean;
}

const maxWidth = (p: IProps) => (p.fillContent ? '36.25rem' : '100%');
const elementPadding = (p: IProps) => (p.fillContent ? '0 1.5rem' : '0 7.5rem');

const Container = styled.div`
  margin: 0 auto;
  padding: 0.875rem 2.5%;
  max-width: 67.875rem;
  position: relative;

  @media (min-width: 768px) {
    padding: 2rem;
  }
`;

const isDisplay = ({ isDisplayed = false }: { isDisplayed: boolean }) => (isDisplayed ? 'block' : 'none');

const PaymentNotificationSpinnerContainer = styled.div<{ isDisplayed: boolean }>`
  display: ${isDisplay};
  position: absolute;
  color: white;
  background-color: white;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
`;

const Section = styled.section`
  background-color: ${secondaryBg};
  margin: auto;
  display: flex;
  border-radius: 0.625rem;
`;

const Wrapper = styled.div`
  position: relative;
  overflow: auto;
  height: 100%;
`;

const Main = styled.div.attrs({
  role: 'main',
})`
  background-color: ${whiteDarker};
  flex-grow: 1;
  flex-basis: calc(100% - 20.8125rem);
  z-index: 1;
  position: relative;

  @media (min-width: 768px) {
    border-radius: 0.625rem;
    box-shadow: 0.25rem 0 1.25rem 0 rgba(55, 52, 50, 0.1);
  }
`;

const MainWrapper = styled.div`
  @media (min-width: 768px) {
    margin: 3.25rem ${(24 * 100) / (24 + 368 + 24)}% 4.9375rem;
  }

  @media (min-width: 1024px) {
    margin: 3.25rem 0 4.9375rem;
  }
`;

const HeaderTextWrapper = styled.h2`
  max-height: 3rem;
  color: ${secondaryBlack};
  font-family: ${fontMontserrat};
  font-size: 1.375rem;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.45;
  letter-spacing: normal;
  padding-bottom: 1.5rem;
  margin-left: 0.5rem;

  @media (max-width: 768px) {
    font-size: 1.125rem;
    padding-bottom: 1rem;
  }

  @media (min-width: 768px) {
    margin-left: 0;
    font-weight: normal;
    height: 1.5rem;
    color: ${titleColor};
    line-height: 1.5rem;
    margin: auto;
    margin-bottom: 1.5625rem;
    padding: 0;
    max-width: 33.1875rem;
    padding-bottom: 0;
  }
  @media (min-width: 1024px) {
    max-width: 36.25rem;
    padding: 0 1.5rem;
  }
`;

const Content = styled.div<IProps>`
  box-sizing: content-box;
  margin: auto;
  border-radius: 0.625rem;
  @media (min-width: 768px) {
    max-width: ${maxWidth};
  }
  @media (min-width: 1024px) {
    padding: ${elementPadding};
  }
`;

export {
  Container,
  Section,
  Wrapper,
  Main,
  MainWrapper,
  HeaderTextWrapper,
  Content,
  PaymentNotificationSpinnerContainer,
};
